import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../../../components/ui/Badge';
import useExternalPersonnelText from '../externalPersonnelText';
import { statusOf } from '../externalPersonnelColumns';

const MUTED = 'tw-text-slate-400 dark:tw-text-slate-500';

export const initialsOf = (p) => `${(p['Adı'] || '').charAt(0)}${(p['Soyadı'] || '').charAt(0)}`.toLocaleUpperCase('tr-TR') || '?';

export const STATUS_GRADIENT = {
  aktif: 'tw-from-fuchsia-400 tw-to-purple-600 tw-shadow-fuchsia-500/30',
  inaktif: 'tw-from-slate-400 tw-to-slate-600 tw-shadow-slate-500/30',
  '': 'tw-from-slate-400 tw-to-slate-600 tw-shadow-slate-500/30',
};

/** Aktif / İnaktif (any stored spelling); "-" when empty. */
export const PersonnelStatusBadge = ({ value }) => {
  const { statusLabel } = useExternalPersonnelText();
  const status = statusOf(value);
  if (!status) return value ? <Badge tone="neutral">{value}</Badge> : <span className={MUTED}>-</span>;
  return <Badge tone={status === 'aktif' ? 'success' : 'neutral'}>{statusLabel(status)}</Badge>;
};

PersonnelStatusBadge.propTypes = { value: PropTypes.string };

/** Content of one table cell. */
const PersonnelCell = ({ columnKey, personnel }) => {
  const value = personnel[columnKey];
  if (columnKey === 'Durum') return <PersonnelStatusBadge value={value} />;
  if (columnKey === 'Adı') {
    return (
      <span className="tw-flex tw-min-w-0 tw-items-center tw-gap-2.5">
        <span aria-hidden="true" className={`tw-grid tw-h-7 tw-w-7 tw-shrink-0 tw-place-items-center tw-rounded-full tw-bg-gradient-to-br tw-text-[10px] tw-font-bold tw-text-white tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.45)] ${STATUS_GRADIENT[statusOf(personnel['Durum'])]}`}>
          {initialsOf(personnel)}
        </span>
        <span className="tw-min-w-0 tw-truncate tw-font-semibold tw-text-slate-900 dark:tw-text-white">{value || '-'}</span>
      </span>
    );
  }
  if (!value) return <span className={MUTED}>-</span>;
  return <span className={`tw-block tw-truncate ${columnKey === 'Soyadı' ? 'tw-font-semibold tw-text-slate-900 dark:tw-text-white' : ''}`}>{String(value)}</span>;
};

PersonnelCell.propTypes = { columnKey: PropTypes.string.isRequired, personnel: PropTypes.object.isRequired };

/** One row of the card list (narrow screens). */
export const PersonnelCardRow = ({ personnel }) => (
  <>
    <span aria-hidden="true" className={`tw-grid tw-h-10 tw-w-10 tw-shrink-0 tw-place-items-center tw-rounded-full tw-bg-gradient-to-br tw-text-xs tw-font-bold tw-text-white tw-shadow-[inset_0_1px_0_rgba(255,255,255,0.45)] ${STATUS_GRADIENT[statusOf(personnel['Durum'])]}`}>
      {initialsOf(personnel)}
    </span>
    <span className="tw-min-w-0 tw-flex-1">
      <span className="tw-flex tw-min-w-0 tw-items-center tw-justify-between tw-gap-2">
        <span className="tw-min-w-0 tw-truncate tw-text-[15px] tw-font-semibold tw-text-slate-900 dark:tw-text-white">{`${personnel['Adı'] || ''} ${personnel['Soyadı'] || ''}`.trim() || '-'}</span>
        <PersonnelStatusBadge value={personnel['Durum']} />
      </span>
      <span className="tw-mt-0.5 tw-block tw-truncate tw-text-[13px] tw-text-slate-500 dark:tw-text-slate-400">
        {[personnel['Kurum'], personnel['Ünvan'], personnel['Telefon']].filter(Boolean).join(' · ') || '-'}
      </span>
    </span>
  </>
);

PersonnelCardRow.propTypes = { personnel: PropTypes.object.isRequired };

export default PersonnelCell;
